/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-4">
            <h3 class="font-bold mb-4">Extensions</h3>
            <vue-draggable-container id="wb0" class="wordBank">
              <h5 class="dragBlock my-2  font-semibold cursor-pointer-simulation  ports-block " v-for="extension in extensions" :key="extension">{{extension}}</h5>

            </vue-draggable-container>
          </vx-card>
          <vx-card class="mb-4">
            <h3 class="font-bold mb-4">Values</h3>
            <vue-draggable-container id="wb1" class="wordBank">
              <h5 class="dragBlock my-2  font-semibold cursor-pointer-simulation  ports-block " v-for="value in values" :key="value">{{value}}</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="fourth-sim pt-0">
              <div class="vx-row mb-4">
                <div class="vx-col w-6/12 flex items-center">
                  <h2 class="font-bold">Extensions</h2>
                </div>
                <div class="vx-col w-6/12 flex items-center">
                  <h2 class="font-bold">Values</h2>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt0">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal0">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt1">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal1">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt2">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal2">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt3">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal3">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt4">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal4">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt5">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal5">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt6">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal6">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt7">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal7">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt8">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal8">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt9">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal9">
                  </vue-draggable-container>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import shuffle from 'shuffle-array'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,
      extensions: ['commonName (CN)', 'subjAltName (SAN)', 'extendedKeyUsage', 'policyIdentifier', 'Organization (O)', 'Organization Unit (OU)', 'Location (L)', 'State (ST)', 'Country (C)', 'Private Key Type'],
      values: ['api.intellectualpoint.com', 'DNS Name=*.intellectualpoint.com', 'serverAuth', 'OCSP;URL=http://ocsp.pki.intellectualpoint.com', 'Intellectual Point', 'Information Technology', 'Sterling', 'Virginia', 'USA', '2048-bit RSA'],
      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'
      },

      answers: [
        {
          extension: 'commonName (CN)',
          value: 'api.intellectualpoint.com'
        },
        {
          extension: 'subjAltName (SAN)',
          value: 'DNS Name=*.intellectualpoint.com'
        },
        {
          extension: 'extendedKeyUsage',
          value: 'serverAuth'
        },
        {
          extension: 'policyIdentifier',
          value: 'OCSP;URL=http://ocsp.pki.intellectualpoint.com'
        },
        {
          extension: 'Organization (O)',
          value: 'Intellectual Point'
        },
        {
          extension: 'Organization Unit (OU)',
          value: 'Information Technology'
        },
        {
          extension: 'Location (L)',
          value: 'Sterling'
        },
        {
          extension: 'State (ST)',
          value: 'Virginia'
        },
        {
          extension: 'Country (C)',
          value: 'USA'
        },
        {
          extension: 'Private Key Type',
          value: '2048-bit RSA'
        }
      ]
    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wb0' && overContainer.id !== 'wb1' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          // this.drag_error()
          x.cancel()
        }
      }
    },
    markSimulation () {

      let total_score = 0

      this.answers.forEach(item => {
        for (let i = 0; i < 10; i++) {
          if (document.getElementById(`inputExt${i}`).textContent === item.extension && document.getElementById(`inputVal${i}`).textContent === item.value) {
            total_score++
            document.getElementById(`inputVal${i}`).style.borderColor = '#77FAAE'
            document.getElementById(`inputExt${i}`).style.borderColor = '#77FAAE'
            document.getElementById(`inputVal${i}`).style.backgroundColor = '#77FAAE'
            document.getElementById(`inputExt${i}`).style.backgroundColor = '#77FAAE'
          }
        }
      })

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    draggable,
    Prism
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  created () {
    this.extensions = shuffle(this.extensions)
    this.values = shuffle(this.values)
  }

}
</script>

